// extracted by mini-css-extract-plugin
export default {"fields":"EditTeamForm_fields__RwOtF"};